import {
  DealPartner,
  JapiQuery,
  JapiTableFilter,
  RoleJava,
  UserAccess,
  UserPayloadFields,
  UserWithRolesPayload
} from '../_models/models';

export type UserFormValue = UserPayloadFields & { access: UserAccess };

export function buildUsersFilter(
  fieldName: string,
  operation: JapiTableFilter['operation'],
  value: JapiTableFilter['value']
): JapiQuery {
  return { filter: { filters: [{ fieldName, operation, value }] } };
}

export function subtreeAccountIds(accountOptions: DealPartner[], partnerId: number): number[] {
  const ids = accountOptions.map(account => Number(account.id)).filter(id => id > 0);
  if (ids.length) {
    return ids;
  }
  return partnerId > 0 ? [partnerId] : [];
}

export function buildUserPayload(formValue: UserFormValue, isPartner: boolean, context: {
  roleOptions: RoleJava[];
  partnerId: number;
}): UserWithRolesPayload {
  const { access, ...user } = formValue;
  if (!isPartner) {
    return { user };
  }
  if (!access.roleName) {
    return { user: { ...user, dealPartnerId: context.partnerId } };
  }

  const role = context.roleOptions.find(option => option.name === access.roleName);
  return {
    user: { ...user, dealPartnerId: access.dealPartnerId ?? context.partnerId },
    roles: role ? [{ id: role.id }] : [],
    portfolioIds: access.portfolioIds
  };
}
